const styles = {
  form: {
    display: 'flex',
  },
  button: {
    marginLeft: 'auto',
  },
}

export default styles
